import React from 'react';
import swal from 'sweetalert2';
import {connect} from 'react-redux';
import moment from 'moment';
import {orderBy} from 'lodash';

import {getEndpoint, getHeaders} from '../../../../../helpers/endpoint';
import {styles} from '../../../components/TableRow';

export const getUserPurchases = (
  userId,
  onSuccess = () => {},
  onError = () => {},
) => {
  return (_dispatch, getState) => {
    fetch(getEndpoint('getUserPurchases', userId), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          onError();
          swal({
            title: `Oops...`,
            type: 'error',
            html: `Something went wrong !<br/>${data.error}<br/>`,
          });
        } else {
          onSuccess(data);
        }
      })
      .catch(error => {
        onError();
        swal({
          title: `Oops...`,
          type: 'error',
          html: `Something went wrong !<br/>${error}<br/>`,
        });
      });
  };
};

class UserPurchases extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      purchases: undefined,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user.id !== this.props.user.id) {
      this.setState({purchases: undefined, loading: false});
    }
  }

  render() {
    const {user, dispatch} = this.props;
    const {loading, purchases} = this.state;

    return (
      <React.Fragment>
        <div
          style={{
            marginTop: 16,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          {!loading && (
            <button
              className="btn btn-info"
              onClick={() => {
                this.setState({loading: true});
                dispatch(
                  getUserPurchases(
                    user.id,
                    response =>
                      this.setState({
                        loading: false,
                        purchases: orderBy(
                          response.purchases,
                          ['purchasedAt'],
                          ['desc'],
                        ),
                      }),
                    () => this.setState({loading: false}),
                  ),
                );
              }}>
              Fetch purchases
            </button>
          )}
        </div>
        <div style={{width: '100%'}}>
          {purchases && (
            <div className="table-responsive table-fixed-height">
              <table className="table table-sm table-responsive table-striped">
                <thead>
                  <tr>
                    <th>Platform</th>
                    <th>ProductId</th>
                    <th>purchasedAt</th>
                    <th>userId</th>
                    <th>paymentMethod</th>
                  </tr>
                </thead>
                <tbody>
                  {purchases.map(purchase => (
                    <tr key={purchase.productId + purchase.purchasedAt}>
                      <th>{purchase.platform}</th>
                      <th style={styles.value}>{purchase.productId}</th>
                      <th style={styles.value}>
                        {moment(purchase.purchasedAt).format('DD/MM/YY, HH:mm')}
                      </th>
                      <th style={styles.value}>{purchase.userId}</th>
                      <th style={styles.value}>{purchase.paymentMethod}</th>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(UserPurchases);



// WEBPACK FOOTER //
// ./src/pages/Support/User/components/Purchases/index.js